<section class="dashboard-page">
  <div class="page-toolbar">
    <div>
      <strong>MSLDC RE Scheduling &amp; Deviation Accounting Dashboard</strong
      ><span>Real-time operational overview</span>
    </div>
  </div>

  <section class="kpi-grid">
    @for (kpi of kpis; track kpi.label) {
      <article class="kpi-card">
        <span class="kpi-icon" [class]="kpi.tone">{{ kpi.icon }}</span>
        <div class="kpi-content" [class.current-block-kpi]="kpi.label === 'Current Block'">
          @if (kpi.label === "Current Block") {
            <small>{{ kpi.label }}</small
            ><strong>{{ currentDsmBlock }}</strong
            ><span class="current-block-window">{{
              currentDsmBlockWindow
            }}</span>
          } @else {
            <small>{{ kpi.label }}</small
            ><strong [class.negative]="kpi.value.startsWith('-')">{{ kpi.value }}</strong
            ><em [class.negative]="kpi.detail.includes('↘') || kpi.value.startsWith('-')">{{
              kpi.detail
            }}</em>
          }
        </div>
      </article>
    }
  </section>

 

  <section class="main-grid">
    <article #schedulePanel class="panel line-panel chart-panel">
      <div class="panel-title">
        <div>
          <h2>STATE GENERATION vs SCHEDULE <small>(Today till now)</small></h2>
        </div>
        <div class="chart-filter" aria-label="Schedule chart filters">
          <label
            ><span class="sr-only">Period</span
            ><select
              [value]="selectedSchedulePeriod"
              (change)="onSchedulePeriodChange($any($event.target).value)"
            >
              @for (period of schedulePeriods; track period) {
                <option [value]="period">{{ period }}</option>
              }
            </select></label
          >
          <label
            ><span class="sr-only">X-axis mode</span
            ><select
              [value]="selectedXAxisModes.schedule"
              (change)="
                onChartXAxisModeChange('schedule', $any($event.target).value)
              "
            >
              @for (mode of xAxisModes; track mode.id) {
                <option [value]="mode.id">{{ mode.label }}</option>
              }
            </select></label
          >
          <div class="chart-actions">
            <button type="button" title="View chart in full screen" aria-label="View schedule chart in full screen" (click)="toggleFullscreen(schedulePanel)">⛶</button>
          </div>
        </div>
      </div>
      <div class="legend schedule-legend">
        <span class="actual" [class.disabled]="isScheduleSeriesHidden('Actual Generation')" (click)="toggleScheduleSeries('Actual Generation')">Actual Generation</span
        ><span class="schedule" [class.disabled]="isScheduleSeriesHidden('Scheduled Generation')" (click)="toggleScheduleSeries('Scheduled Generation')">Scheduled Generation</span
        ><span class="avc" [class.disabled]="isScheduleSeriesHidden('Day Ahead Schedule')" (click)="toggleScheduleSeries('Day Ahead Schedule')">Day Ahead Schedule</span>
      </div>
      <div class="line-chart">
        <div
          #scheduleChart
          class="highchart"
          aria-label="Schedule, actual generation and available capacity chart"
        ></div>
      </div>
    </article>

    <article #windPanel class="panel resource-panel chart-panel">
      <div class="panel-title">
        <h2>GENERATION BY WIND <small>(Today till now)</small></h2>
        <div class="chart-filter" aria-label="Wind chart x-axis mode">
          <label
            ><span class="sr-only">X-axis mode</span
            ><select
              [value]="selectedXAxisModes.wind"
              (change)="
                onChartXAxisModeChange('wind', $any($event.target).value)
              "
            >
              @for (mode of xAxisModes; track mode.id) {
                <option [value]="mode.id">{{ mode.label }}</option>
              }
            </select></label
          >
          <div class="chart-actions">
            <button type="button" title="View chart in full screen" aria-label="View wind chart in full screen" (click)="toggleFullscreen(windPanel)">⛶</button>
          </div>
        </div>
      </div>
      <div
        #windChart
        class="highchart"
        aria-label="Wind generation chart"
      ></div>
    </article>
    <article #solarPanel class="panel resource-panel chart-panel">
      <div class="panel-title">
        <h2>GENERATION BY SOLAR <small>(Today till now)</small></h2>
        <div class="chart-filter" aria-label="Solar chart x-axis mode">
          <label
            ><span class="sr-only">X-axis mode</span
            ><select
              [value]="selectedXAxisModes.solar"
              (change)="
                onChartXAxisModeChange('solar', $any($event.target).value)
              "
            >
              @for (mode of xAxisModes; track mode.id) {
                <option [value]="mode.id">{{ mode.label }}</option>
              }
            </select></label
          >
          <div class="chart-actions">
            <button type="button" title="View chart in full screen" aria-label="View solar chart in full screen" (click)="toggleFullscreen(solarPanel)">⛶</button>
          </div>
        </div>
      </div>
      <div
        #solarChart
        class="highchart"
        aria-label="Solar generation chart"
      ></div>
    </article>
  </section>

   <section class="dsm-summary-grid" aria-label="DSM schedule summaries">
    <article class="dsm-summary">
      <h2><i class="blue" aria-hidden="true">▣</i> TODAY DSM <small>(Today till now)</small></h2>
      <div class="dsm-values">
        <span>Schedule (MWh)<b>10,758.15</b></span
        ><span>Actual (MWh)<b>10,245.80</b></span
        ><span>Deviation (MWh)<b class="negative">-512.35</b></span
        ><span>Deviation (%)<b class="negative">-4.77%</b></span>
        <span>Payable / Receivable (₹)<b class="positive">12,45,320</b></span>

      </div>
     
    </article>
    <article class="dsm-summary">
      <h2>
        <i class="violet" aria-hidden="true">▤</i> THIS WEEK DSM <small>({{ thisWeekDateRange }})</small>
      </h2>
      <div class="dsm-values">
        <span>Schedule (MWh)<b>1,72,450.60</b></span
        ><span>Actual (MWh)<b>1,65,320.40</b></span
        ><span>Deviation (MWh)<b class="negative">-7,130.20</b></span
        ><span>Deviation (%)<b class="negative">-4.13%</b></span>
        <span >Payable / Receivable (₹)<b class="positive">1,35,62,450</b></span>
      </div>
    
    </article>
    <article class="dsm-summary">
      <h2>
        <i class="orange" aria-hidden="true">◴</i> PREVIOUS WEEK DSM
        <small>({{ previousWeekDateRange }})</small>
      </h2>
      <div class="dsm-values">
        <span>Schedule (MWh)<b>1,68,230.40</b></span
        ><span>Actual (MWh)<b>1,63,850.20</b></span
        ><span>Deviation (MWh)<b class="negative">-4,380.20</b></span
        ><span>Deviation (%)<b class="negative">-2.60%</b></span>
        <span>Payable / Receivable (₹)<b class="positive">78,45,320</b></span>
      </div>
     
    </article>
  </section>

  <section class="registration-row">
    <article #deviationPanel class="panel line-panel deviation-panel chart-panel">
      <div class="deviation-heading">
        <span>MW</span>
        <h2>Deviation Trend <small>(Today till now)</small></h2>
        <div class="chart-filter" aria-label="Deviation chart x-axis mode">
          <label
            ><span class="sr-only">X-axis mode</span
            ><select
              [value]="selectedXAxisModes.deviation"
              (change)="
                onChartXAxisModeChange('deviation', $any($event.target).value)
              "
            >
              @for (mode of xAxisModes; track mode.id) {
                <option [value]="mode.id">{{ mode.label }}</option>
              }
            </select></label
          >
          <div class="chart-actions">
            <button type="button" title="View chart in full screen" aria-label="View deviation chart in full screen" (click)="toggleFullscreen(deviationPanel)">⛶</button>
          </div>
        </div>
      </div>
      <div
        #deviationChart
        class="highchart"
        aria-label="Deviation trend chart"
      ></div>
    </article>
    <article #mapPanel class="panel map-panel chart-panel">
      <div class="panel-title">
        <h2>GIS MAP - RE ASSETS &amp; WEATHER IMPACTED PSS <small>(Live)</small></h2>
      </div>

      <div class="google-map-wrap">
        <div
          #googleMap
          class="google-map"
          aria-label="Google map showing renewable energy assets"
        ></div>

        <!-- Maharashtra boundary label -->
        <div class="maharashtra-label">Maharashtra</div>

        <div class="google-map-legend" aria-label="Renewable asset and weather alert legend">
          <div class="asset-map-legend">
            <span class="solar">Solar Plants</span>
            <span class="wind">Wind Farms</span>
          </div>
          <div class="weather-impact-map-legend">
            <span><img [src]="weatherIconData('Sunny')" alt="" />Sunny</span>
            <span><img [src]="weatherIconData('Partly Cloudy')" alt="" />Partly Cloudy</span>
            <span><img [src]="weatherIconData('Thunderstorm')" alt="" />Stormy</span>
            <span><img [src]="weatherIconData('Heavy Rain')" alt="" />Rainy</span>
          </div>
        </div>

        @if (googleMapsError) {
          <div class="google-map-error">
            Google Map could not be loaded. Check <code>google_map_key</code> in
            the active environment configuration.
          </div>
        }
      </div>
    </article>
  </section>

  <section class="bottom-grid">
    <article class="panel top-pss-panel">
      <div class="panel-heading">
        <h2>
          TOP 10 CRITICAL PSS BY DEVIATION
        </h2>
        <a href="#">View All</a>
      </div>
      <div class="top-pss-table-wrap">
        <table class="top-pss-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>PSS Name</th>
              <th>QCA Name</th>
              <th>Schedule (MW)</th>
              <th>Actual (MW)</th>
              <th>Deviation (MW)</th>
              <th>Deviation (%)</th>
              <th>Dsm Amount</th>
            </tr>
          </thead>
          <tbody>
            @for (row of topPssDeviations; track row.pssCode) {
              <tr>
                <td>{{ row.rank }}</td>
                <td>
                  <a
                    [href]="'/pss-dashboard/' + row.pssCode"
                    (click)="$event.preventDefault(); navigateToPssDashboard(row.pssCode)"
                  >{{ row.pssName }}</a>
                </td>
                <td>
                  <a
                    [href]="'/qca-dashboard?qca=' + row.qcaCode + '&pss=' + row.pssCode"
                    (click)="$event.preventDefault(); navigateToQcaDashboard(row.qcaCode, row.pssCode)"
                  >{{ row.qcaName }}</a>
                </td>
                <td>{{ row.schedule | number: "1.2-2" }}</td>
                <td>{{ row.actual | number: "1.2-2" }}</td>
                <td
                  [class.positive-deviation]="row.deviation >= 0"
                  [class.negative-deviation]="row.deviation < 0"
                >
                  {{ row.deviation >= 0 ? "+" : ""
                  }}{{ row.deviation | number: "1.2-2" }}
                </td>
                <td
                  [class.positive-deviation]="row.deviationPercent >= 0"
                  [class.negative-deviation]="row.deviationPercent < 0"
                >
                  {{ row.deviationPercent >= 0 ? "+" : ""
                  }}{{ row.deviationPercent | number: "1.2-2" }}%
                    
                </td>
                <td>{{ row.deviationAmount | number: "1.2-2" }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <p class="top-pss-hint">
        * Click on PSS Name or QCA Name to view details
      </p>
    </article>

    <article class="panel notifications-panel">
      <div class="panel-heading">
        <h2>Recent Alerts</h2>
        <a href="#">View All</a>
      </div>
      <div class="notifications-list">
        @for (alert of alerts; track alert.title + alert.time) {
          <article class="notification-item">
            <i [class]="alert.level">{{ alert.level === 'success' ? '✓' : alert.level === 'info' ? 'i' : '!' }}</i>
            <div><b>{{ alert.title }}</b><small>{{ alert.detail }}</small></div>
            <time>{{ alert.time }}</time>
          </article>
        }
      </div>
    </article>
  </section>

</section>
